import { Button, ButtonProps } from "@instructure/ui-buttons";
import { useFormState } from "react-final-form";
import { Text } from "@instructure/ui-text";

function useSubmitDisabledMessage(): string | true | null {
    const formState = useFormState({ subscription: { submitting: true, dirty: true } });
    if (formState.submitting) {
        return true // 'Submitting Form'
    } else if (!formState.dirty) {
        return 'No changes made'
    }
}

export const FormSubmitButton: React.SFC<ButtonProps & { handleSubmit }> = ({ handleSubmit, ...props }) => {
    const disabledHint = useSubmitDisabledMessage();

    return <Button
        interaction={disabledHint ? 'disabled' : 'enabled'}
        margin="0 0 0 x-small"
        color="primary"
        onClick={handleSubmit}
        children="Save"
        {...props}
    />
}

export const FormSubmitDisabledReason = () => {
    const disabledHint = useSubmitDisabledMessage();
    if (!disabledHint || disabledHint == true) return null;
    return <Text color="secondary" size="x-small" fontStyle="italic">{disabledHint}</Text>
}
